module.exports = __webpack_public_path__ + "img/biology.1642e55a.png";